// Module
var code = "<administration-accounts-employees-grid title=\"$ctrl.title\"></administration-accounts-employees-grid>\n\n<tabs-navigation identifier=\"app.administration.accounts.siteLocations\"\n                 state=\"app.administration.accounts.siteLocations.employees\">\n</tabs-navigation>\n";
// Exports
module.exports = code;